import type { SemanticICONS } from 'semantic-ui-react';

export interface MobileMenuItem {
  key: string;
  title: string;
  description: string;
  path: string;
  icon: SemanticICONS;
}

export const teamLeaderMobileNavData: MobileMenuItem[] = [
  {
    key: 'culture-hub',
    title: 'Dashboard',
    description: 'Open collaboration insights for your team.',
    path: '/app/mobile/culture-hub',
    icon: 'line graph',
  },
  {
    key: 'interventions',
    title: 'Team Feedback',
    description: 'Review action areas and next-step plans for your team.',
    path: '/app/mobile/interventions',
    icon: 'bullseye',
  },
  {
    key: 'focus-areas',
    title: 'Focus Plan',
    description: 'Review your saved focus plan items in one place.',
    path: '/app/mobile/focus-areas',
    icon: 'clipboard list',
  },
  {
    key: 'leaderboard',
    title: 'Leaderboard',
    description: 'View team leader rankings and accomplishment badges.',
    path: '/app/mobile/leaderboard',
    icon: 'trophy',
  },
  {
    key: 'knowledge-base',
    title: 'Knowledge Base',
    description: 'Search policies, guides and support resources.',
    path: '/app/mobile/knowledge-base',
    icon: 'book',
  },
  {
    key: 'guided-summary',
    title: 'Guided Summary',
    description: 'Start the guided summary slideshow.',
    path: '/app/mobile/guided-summary',
    icon: 'play',
  },
  {
    key: 'glossary',
    title: 'Glossary',
    description: 'Review culture terms and business definitions.',
    path: '/app/mobile/glossary',
    icon: 'info circle',
  },
  {
    key: 'logout',
    title: 'Logout',
    description: 'Sign out and return to the login screen.',
    path: '/account/logout',
    icon: 'sign-out',
  },
];

export const orgAdminMobileNavData: MobileMenuItem[] = [
  {
    key: 'org-admin',
    title: 'Organization Insights',
    description: 'View org-level insights and admin workflows.',
    path: '/app/mobile/org-admin',
    icon: 'chart bar',
  },
  {
    key: 'leaderboard',
    title: 'Leaderboard',
    description: 'View team leader rankings and accomplishment badges.',
    path: '/app/mobile/leaderboard',
    icon: 'trophy',
  },
  {
    key: 'interventions',
    title: 'Interventions',
    description: 'Review action areas and next-step plans for your team.',
    path: '/app/mobile/interventions',
    icon: 'bullseye',
  },
  {
    key: 'focus-areas',
    title: 'Focus Areas',
    description: 'Review your saved focus plan items in one place.',
    path: '/app/mobile/focus-areas',
    icon: 'clipboard list',
  },
  {
    key: 'knowledge-base',
    title: 'Knowledge Base',
    description: 'Search policies, guides and support resources.',
    path: '/app/mobile/knowledge-base',
    icon: 'book',
  },
  {
    key: 'glossary',
    title: 'Glossary',
    description: 'Review culture terms and business definitions.',
    path: '/app/mobile/glossary',
    icon: 'info circle',
  },
  {
    key: 'logout',
    title: 'Logout',
    description: 'Sign out and return to the login screen.',
    path: '/account/logout',
    icon: 'sign-out',
  },
];

export const staffMobileNavData: MobileMenuItem[] = [
  {
    key: 'staff',
    title: 'Admin Toolbox',
    description: 'Open staff and superuser tools for mobile management.',
    path: '/app/mobile/staff',
    icon: 'settings',
  },
  {
    key: 'logout',
    title: 'Logout',
    description: 'Sign out and return to the login screen.',
    path: '/account/logout',
    icon: 'sign-out',
  },
];

export const defaultMobileNavData: MobileMenuItem[] = [
  {
    key: 'logout',
    title: 'Logout',
    description: 'Sign out and return to the login screen.',
    path: '/account/logout',
    icon: 'sign-out',
  },
];

export const getMobileNavData = ({
  isTeamLeader,
  isOrgAdmin,
  isStaffOrSuperAdmin,
  hasLeadershipTeams = false,
}: {
  isTeamLeader: boolean;
  isOrgAdmin: boolean;
  isStaffOrSuperAdmin: boolean;
  hasLeadershipTeams?: boolean;
}): MobileMenuItem[] => {
  if (isTeamLeader || (isOrgAdmin && hasLeadershipTeams)) {
    return teamLeaderMobileNavData;
  }
  if (isOrgAdmin) {
    return orgAdminMobileNavData;
  }
  if (isStaffOrSuperAdmin) {
    return staffMobileNavData;
  }
  return defaultMobileNavData;
};
